import EventEmitter from "./EventEmitter";
import Utils from "./Utils";
import IntroHints from "./IntroHints";

export default class Intro extends EventEmitter {
  constructor(json, scope, translations, tracker) {
    super();
    this.IS_FINISHED = false;
    this.scope = scope;
    this.translations = translations;
    this.tracker = tracker;
    this.scale = this.scope.IMAGE.DRAWING.SCALE;
    this.colorizeBTN = document.querySelector(".button-wrapper");
    this.handler = {
      animationCompleted: this.onAnimationCompleted.bind(this),
      textureupdated: this.onIntroEnd.bind(this),
      mouseDown: this.onMouseDown.bind(this),
    };

    // set intro hints
    this.introHints = new IntroHints(
      document.querySelector(".introHints"),
      this.translations
    );
    //
    this.skip = document.querySelector(".skip");
    this.skipButton = document.querySelector("#skip_button");

    this.skipButton.addEventListener("mousedown", this.handler.mouseDown);
    //
    this.timeouts = [];
    // load Seq param
    this.init(json);
  }
  onResize(dimensions) {
    this.scale = this.scope.IMAGE.DRAWING.SCALE;
    // this.introHints.onResize(dimensions);
    this.reset();
    // this.skip.classList.add("hide");
    // this.introHints.hintReset();
  }

  async init(url) {
    this.sequence = await Utils.load(url);
    this.loadSequenceData(this.sequence.drawingid);
  }

  async loadSequenceData(drawingid) {
    this.url = `${GLOBAL_PATH}drawing/${drawingid}`;
    this.activeLines = await Utils.load(this.url);
    // make ready for step 3
    this.scope.IMAGE.DRAWING.addEventListener(
      "completed",
      this.handler.animationCompleted
    );

    // this.scope.IMAGE.setDataForIntro(this.activeLines, 10);
    // this.scope.loader.hide();
    //

    /**
     *  STEP 1 : draw with magic pen
     */
    // this.introHints.demo();
    this.line = [];
    this.scope.IMAGE.state = "magic";
    this.scope.IMAGE.DRAWING.lines = this.activeLines;
    this.drawUserlines(
      JSON.parse(JSON.stringify(this.sequence.scrambledPoints)),
      this.drawMagic.bind(this),
      true
    );
    this.scope.loader.hide();
    this.scope.ui.hideSwitch();
    this.introHints.addArrow();
    this.introHints.setArrowLeft();
    this.introHints.show("step1");
    this.introHints.moveTo(document.querySelector("li.magic"));
    this.skip.classList.remove("hide");
  }

  drawMagic() {
    /**
     *  STEP 2 : transform with magic
     */
    if (!this.IS_FINISHED) {
      this.scope.IMAGE.DRAWING.animator.DEFAULT_SPEED = 25;
      this.scope.IMAGE.DRAWING.animator.AUTOMATED_EXTRA_STEPS =
        this.scope.IMAGE.DRAWING.length - 1;
      this.scope.IMAGE.DRAWING.simplifyPoints = this.scope.IMAGE.activePoint;
    }
  }

  onAnimationCompleted(e) {
    /**
     *  STEP 3 : finish drawing with hand drawing
     */

    if (!this.IS_FINISHED) {
      console.log("ANIMATION COMPLETED");
      this.scope.IMAGE.DRAWING.removeEventListener("completed");
      // FINISH THE DRAWINGS WITH EXTRA LINES ?
      this.scope.ui.force("pen");
      this.line = [];
      this.drawUserlines(
        this.sequence.userpoints,
        this.setupUserColor.bind(this),
        false,
        this.sequence.speed
      );
      this.introHints.show("step2");
      this.introHints.moveTo(document.querySelector("li.pen"));
      this.timeouts.push(
        setTimeout(() => {
          this.introHints.show("step3");
        }, 4000)
      );
    }

    // ADD COLOR DOTS
    // // test reset
    // console.log("TEST RESET");
    // this.scope.IMAGE.resetDataAfterIntro();
    // this.scope.reset();
  }
  setupUserColor() {
    /**
     *  PRE-STEP 4 : prepare UI
     */
    console.log("SETUP USER COLOR");
    this.timeouts.push(
      setTimeout(() => {
        this.scope.ui.force("color");
        this.scope.ui.hidePalette();
        // this.scope.activateInteraction();
        document.getElementById("colorSource").classList.remove("hide");

        // this.drawUserColor();
        /**
         * NEW DESIGN FOR LINES
         */
        this.drawUserColorLines();
        this.introHints.moveTo(document.querySelector("li.color"));
        this.introHints.show("step4");
      }, 1500)
    );
  }
  drawUserColor() {
    /**
     *  STEP 4 : add custom colors to the drawing
     */
    // console.log("COLOR");
    // if (this.scope.state != "color") this.scope.ui.force("color");
    if (!this.IS_FINISHED) {
      if (this.sequence.colorPoints.length > 0) {
        const point = this.sequence.colorPoints.shift();
        // console.log(point);
        this.scope.colorData.paint(
          this.scope.colorData.color_ctx,
          point.x * this.scale,
          point.y * this.scale,
          10 * this.scale,
          point.color
        );
        this.scope.colorData.paint(
          this.scope.colorData.position_ctx,
          point.x * this.scale,
          point.y * this.scale,
          10 * this.scale
        );
        this.timeouts.push(
          setTimeout(() => {
            this.drawUserColor();
          }, 50)
        );
      } else {
        console.log("USER COLOR STOPPED, RUN COLORIZE 182");
        this.scope.colorizedImage.addEventListener(
          "textureupdated",
          this.handler.textureupdated
        );
        this.scope.transformImage(true);
        //show colorize button
        this.introHints.moveTo(this.colorizeBTN);
        this.colorizeBTN.classList.remove("hidden");
        this.introHints.show("step5");
      }
    }
  }

  /*
     NEW FUNCTION TO DRAW COLORS
     BASED ON LINES
  */
  drawUserColorLines() {
    if (!this.IS_FINISHED) {
      if (this.sequence.colorLines.length > 0) {
        if (!this.lineToDraw) {
          this.lineToDraw = this.sequence.colorLines.shift();
          // preset allPoints for the line
          // !! SCALE IS NOT CORRECT
          const lineScaled = this.lineToDraw.line.map((obj) => ({
            x: obj.x * this.scale,
            y: obj.y * this.scale,
          }));
          console.log(lineScaled);

          this.scope.colorData.convertLines2Points(
            lineScaled,
            this.lineToDraw.color
          );
        }
        if (this.lineToDraw.line.length > 1) {
          this.scope.colorData.color_ctx.beginPath();
          // const color = this.scope.ui.color_palette.hexToRgb(
          //   this.lineToDraw.color
          // );
          this.scope.colorData.color_ctx.strokeStyle = this.lineToDraw.color;
          this.scope.colorData.color_ctx.lineWidth = 5 * this.scale;
          this.scope.colorData.color_ctx.lineCap = "round";
          this.scope.colorData.color_ctx.moveTo(
            this.lineToDraw.line[0].x * this.scale,
            this.lineToDraw.line[0].y * this.scale
          );
          this.scope.colorData.color_ctx.lineTo(
            this.lineToDraw.line[1].x * this.scale,
            this.lineToDraw.line[1].y * this.scale
          );
          this.scope.colorData.color_ctx.stroke();
          this.scope.colorData.color_ctx.closePath();
          this.lineToDraw.line.shift();
        } else {
          this.lineToDraw = null;
        }
        this.timeouts.push(
          setTimeout(() => {
            this.drawUserColorLines();
          }, 0)
        );
      } else {
        console.log("USER COLOR STOPPED, RUN COLORIZE 247");
        // ready for conversion
        this.scope.colorizedImage.addEventListener(
          "textureupdated",
          this.handler.textureupdated
        );
        this.scope.transformImage(true);
        //show colorize button
        // a delay to wait until the panel has opened for the placement of the introhint.
        if (Utils.isSmallOrMediumLayout()) this.introHints.setOpacity(0);
        const delay = Utils.isSmallOrMediumLayout() ? 500 : 0;
        const direction = Utils.isSmallOrMediumLayout() ? "bottom" : "top";
        const offsetY = Utils.isSmallOrMediumLayout() ? -12 : 0;
        // TODO:  add a THEN for moveto
        this.timeouts.push(
          setTimeout(() => {
            this.introHints.setOpacity(1);
            this.introHints.moveTo(this.colorizeBTN, direction, offsetY);
            this.colorizeBTN.classList.remove("hidden");
            this.introHints.show("step5");
          }, delay)
        );
      }
    }
  }

  drawUserlines(userpoints, callback, magic = false, speed = 50) {
    if (!this.IS_FINISHED) {
      // console.log("userpoints", userpoints.length);
      let activePoint = null;
      // console.log(this.sequence.userpoints.length);
      if (userpoints.length > 0 && this.line.length == 0) {
        this.line = userpoints.shift();
      } else if (userpoints.length == 0 && this.line.length == 0) {
        console.log("USER LINE STOPPED");

        callback();
        return;
      }
      // console.log("WHAT THE LINE", this.line);
      if (this.line.length > 0) {
        const p1 = this.line.shift();
        const p2 = this.line[0];
        if (p2) {
          const activePoint = [
            { x: p1.x * this.scale, y: p1.y * this.scale },
            { x: p2.x * this.scale, y: p2.y * this.scale },
          ];
          if (!magic) {
            this.scope.IMAGE.DRAWING.drawLine(
              activePoint,
              this.scope.IMAGE.DRAWING.LINE_COLOR,
              this.scope.IMAGE.ctx
            );
            this.scope.IMAGE.DRAWING.print(this.scope.IMAGE.ctx);
          } else {
            this.scope.IMAGE.activePoint.push({
              x: p1.x * this.scale,
              y: p1.y * this.scale,
            });
          }
        }
        this.timeouts.push(
          setTimeout(() => {
            this.drawUserlines(userpoints, callback, magic, speed);
          }, speed)
        );
      }

      // this.DRAWING.drawLine(this.activePoint, this.DRAWING.color, this.ctx);
      // this.DRAWING.print(this.ctx);
    }
  }

  onIntroEnd(data) {
    // this.scope.colorizedImage.removeEventListener("textureupdated");
    if (!this.IS_FINISHED) {
      console.log("INTRO END TOTALLY");
      this.showAllTools();
      this.introHints.setOpacity(0);
      this.introHints.setText("step6");
      this.timeouts.push(
        setTimeout(() => {
          this.introHints.moveTo(document.querySelector("li.magic"));
        }, 500)
      );

      this.timeouts.push(
        setTimeout(() => {
          console.log("RESETTED ?");
          // this.scope.ui.force("magic");
          this.scope.IMAGE.resetDataAfterIntro();
          this.scope.reset();
          this.scope.organizeUI();
          this.IS_FINISHED = true;
          // reset Interactive image
          this.scope.colorizedImage.reset();
          this.introHints.hide();
          // hide skip
          this.timeouts.push(
            setTimeout(() => {
              this.skip.classList.add("hide");
              this.raiseEvent("intro_ended", []);
              this.skipButton.removeEventListener(
                "mousedown",
                this.handler.mouseDown
              );
              // activate UI
              this.scope.activateInteraction();
              this.showAllTools();
              if (this.tracker) this.tracker.track("intro_complete");
            }, 5000)
          );
          this.showTryHint();
        }, 7000)
      );
    }
  }

  showTryHint() {
    this.raiseEvent("show_try_hint", []);
  }

  onMouseDown(e) {
    this.skipButton.removeEventListener("mousedown", this.handler.mouseDown);
    this.skipButton.style.opacity = 0;
    this.skipButton.style.pointerEvents = "none";
    this.reset();
    this.raiseEvent("skip", []);
  }

  start() {
    console.log("START INTRO");
  }

  showAllTools() {
    const buttons = document.querySelectorAll("li.invisible");
    buttons.forEach((button) => {
      button.classList.remove("invisible");
    });
    // also hide the colorize button
    const colorizeBtn = document.querySelector(".button-wrapper");
    colorizeBtn.classList.add("hidden");
    colorizeBtn.classList.remove("deactivated-but-visible");
  }

  reset() {
    if (!this.IS_FINISHED) {
      this.skip.classList.add("hide");
      this.raiseEvent("intro_ended", []);
      this.IS_FINISHED = true;
      // clear all timed sequence
      this.timeouts.forEach((timeout) => {
        clearTimeout(timeout);
      });
      this.scope.IMAGE.DRAWING.KILLING = true;
      this.scope.colorizedImage.stop();
      this.scope.colorizedImage.reset();
      // reset Worker
      this.scope.ImageLoaderWorker.terminate();
      this.scope.initImageWorker();
      // FB WORKER
      this.scope.FBListener.imageListener();
      this.scope.FBListener.resume = false;
      this.scope.FBListener.initImageListener();
      // clear timeout
      clearTimeout(this.scope.SAFETY_TIMEOUT);

      this.scope.IMAGE.resetDataAfterIntro();
      this.scope.reset();
      this.scope.colorizedImage.reset();
      this.scope.organizeUI();
      // activate UI
      this.scope.activateInteraction();
      this.introHints.setText("step6");
      this.timeouts.push(
        setTimeout(() => {
          this.introHints.moveTo(document.querySelector("li.magic"));
        }, 1500)
      );
    }
  }
}
